import React, { useEffect, useRef } from 'react';
const BASE_CONFIG = {
  allow_symbol_change: true,
  calendar: false,
  save_image: true,
  locale: 'en',
  style: '1',
  symbol: 'OANDA:XAUUSD',
  theme: 'dark',
  timezone: 'America/New_York',
  backgroundColor: '#0F0F0F',
  gridColor: 'rgba(242, 242, 242, 0.2)',
  compareSymbols: [],
  studies: ['STD;Trading%1Sessions'],
  autosize: true
};
const DESKTOP_CONFIG = {
  ...BASE_CONFIG,
  details: true,
  hide_side_toolbar: false,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: false,
  hotlist: true,
  withdateranges: true,
  watchlist: ['OANDA:XAUUSD', 'BINANCE:BTCUSDT', 'FOREXCOM:EURUSD', 'CAPITALCOM:NAS100', 'CAPITALCOM:SPX500']
};

/* On phones the watchlist and details panels eat the whole canvas,
   so the price chart gets the full width instead. */
const MOBILE_CONFIG = {
  ...BASE_CONFIG,
  details: false,
  hide_side_toolbar: false,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: true,
  hotlist: false,
  withdateranges: false,
  watchlist: []
};
interface TradingViewChartProps {
  /** Fill the parent container instead of using the default framed sizing. */
  fill?: boolean;
  /** TradingView interval code, e.g. "15", "60", "1W". */
  interval?: string;
}
export function TradingViewChart({
  fill = false,
  interval = '15'
}: TradingViewChartProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;
    const config = {
      ...(isMobile ? MOBILE_CONFIG : DESKTOP_CONFIG),
      interval
    };
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify(config);
    container.appendChild(script);
    return () => {
      container.innerHTML = '';
    };
  }, [interval]);
  return <div className={fill ? 'h-full w-full' : 'h-[68vh] min-h-[420px] w-full lg:h-[calc(100vh-220px)] lg:min-h-[560px]'} data-id="element-179" data-mp="3qqdionyt0dx">
      <div className="tradingview-widget-container h-full w-full" ref={containerRef} data-id="element-180" data-mp="3qvodeo0tum4o">
        <div className="tradingview-widget-container__widget h-full w-full" data-id="element-181" data-mp="rgay1bzro5pb" />
      </div>
    </div>;
}